<template>
  <div class="tile shadowed">
    <header>
      <h2>{{playlist.name}}</h2>
      <button @click="$router.push('/trainee/scenario/13/playlist/'+ playlist.id)">
        <i class="material-icons">open_in_new</i>
        <span>Open</span>
      </button>
    </header>
    <figure>
      <img :src="playlist.thumb ? playlist.thumb : require('@/assets/playlist-thumbnail@2x.png')" />
    </figure>
    <footer>
      <div>
        <i class="material-icons">question_answer</i>
        <span v-if="playlist.subTags">{{playlist.subTags[0]}}</span>
      </div>
      <div>
        <i class="material-icons">access_time</i>
        <span>{{playlist.duration / 60}} min</span>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "PlaylistTile",
  props: {
    playlist: {
      type: Object,
      default: function () { return {} }
    },
  },
}
</script>

<style lang="scss" scoped>
.tile {
  background-color: #fff;
  padding: 15px;
  margin: 0 auto;
  max-width: 450px;
  width: 100%;
}

header {
  display: flex;
  color: #3D3DDE;

  h2 {
    font-size: 16px;
  }

  button {
    color: #3D3DDE;
    display: flex;
    align-items: center;
    margin-left: auto;
    justify-content: flex-end;
    font-size: 15px;

    i {
      margin-right: 7px;
    }
  }
}

figure {
  position: relative;
  height: 120px;
  margin: 15px 0;

  img {
    object-fit: cover;
    width: 100%;
    height: 120px;
    // height: auto;
  }
}

footer {
  display: flex;
  color: #3D3DDE;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;
    font-size: 15px;

    i {
      margin-right: 7px;
    }
  }
}
</style>